import React from 'react';
import Calendar from './pages/Calendar';

function App() {
  return <Calendar />;
}

export default App;
